export const getOrquestadorApiUrl = (pathname: string) => process.env.REACT_APP_SC_ORQUESTADOR_API_URL + pathname
